package com.milta.feature.spreadsheetimport.data.remote

import com.milta.core.network.apiExceptionOf
import com.milta.core.network.Endpoints
import com.milta.core.network.baseUrl
import com.milta.feature.auth.data.remote.dto.ApiError
import com.milta.feature.spreadsheetimport.data.remote.dto.SpreadsheetImportResultDto
import io.ktor.client.HttpClient
import io.ktor.client.call.body
import io.ktor.client.request.forms.formData
import io.ktor.client.request.forms.submitFormWithBinaryData
import io.ktor.client.statement.HttpResponse
import io.ktor.http.Headers
import io.ktor.http.HttpHeaders
import io.ktor.http.isSuccess

class SpreadsheetImportApi(private val client: HttpClient) {

    /**
     * POST /api/v1/spreadsheet-imports — single synchronous multipart upload, one required field
     * `file` (contrat validé MIL-27, écran B). No session, no `routeId`: the confirmation
     * (`POST /routes/{routeId}/deliveries`) happens separately once the driver has reviewed the rows.
     */
    suspend fun importSpreadsheet(fileBytes: ByteArray, fileName: String): SpreadsheetImportResultDto =
        client.submitFormWithBinaryData(
            url = "$baseUrl/${Endpoints.spreadsheetImports}",
            formData = formData {
                append(
                    key = "file",
                    value = fileBytes,
                    headers = Headers.build {
                        append(HttpHeaders.ContentDisposition, "filename=\"$fileName\"")
                    },
                )
            },
        ).decodeOrThrow()

    private suspend inline fun <reified T> HttpResponse.decodeOrThrow(): T {
        if (!status.isSuccess()) {
            val apiError = runCatching { body<ApiError>() }.getOrNull()
            // MIL-98 — the AI credit 403 keeps its reset date.
            throw apiExceptionOf(status.value, apiError)
        }
        return body()
    }
}
